import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { BsModalService, TypeaheadMatch  } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, of } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { GraphData } from 'src/app/shared/classes/grphData';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-collect-material',
  templateUrl: './collect-material.component.html',
  styleUrls: ['./collect-material.component.less']
})
export class CollectMaterialComponent implements OnInit {
  private service_URL: any;
  selectedRequest:any;
  requestorNameDataSource: Observable<any>;
  requestorNameChanged: boolean = false;
  typeaheadRequestorLoading: boolean;
  flag: boolean;
  isSpinning: boolean;
  travellerNameArray: any[];
  EmployeeFullName: string;
  EmployeeFirstName: string;
  EmployeeLastName: string;
  EmployeeAlias: string;
  EmployeeEmail: string;
  Department: string;
  noResultTravelerName: boolean;
  debounceTimerSearchClient: any;
  public graphData: GraphData[];
  public ClientName: Array<any> = [];
  private unsubscribe$ =new Subject<void>();
  
  
  constructor(private _dataContextService: DataContextService, private toast: ToastrService,private modalService: BsModalService,private trackeromnitureservice:TrackerOmnitureService) {
    this.service_URL = ConstantsService;
   }

  ngOnInit(){
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('collect-material',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.flag= false;
    this.onCollectedByNameSeach();
    this.isSpinning = false;
  }

  onCollectedByNameSeach() {
    this.requestorNameDataSource = Observable.create((observer: any) => {
      let txt = this.EmployeeFullName;
        let url = this.service_URL.Users.graphApi;
        let param = new HttpParams ().set("key",txt);
          this._dataContextService.GetwithValues<any>(url, null,param)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(result => {
          this.travellerNameArray = result;
          observer.next(result);
        },
        (err) => {
          console.log(err);
        }); 
      this.requestorNameChanged = true;
    }).pipe(mergeMap((token: string) => this.getRequestorNamesData(token)));
  }

   searchClient(val : string) {
    clearTimeout(this.debounceTimerSearchClient);

    if (val.length > 2) {
      this.flag = true;
      this.isSpinning = true;    
      let url = this.service_URL.Users.graphApi + '?key=' +val;
      
      this.debounceTimerSearchClient = setTimeout(() => {
        this._dataContextService.get<any>(url)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(res => {
              this.graphData = res;
              this.ClientName = this.graphData;
              this.isSpinning = false;
            },
            (err) => {
              console.log(err);
              this.isSpinning = false;
            })
      }, 300);
    }
    else {
      this.isSpinning = false;
    }
  }

  getRequestorNamesData(token: string): Observable<any> {

    let query = new RegExp(token, 'ig');
    return of(
      this.travellerNameArray.filter((obj: any) => {
        let hostObj = query.test(obj.displayName)
        return obj;
      })
    );
  }

  requestorNameOnSelect(e: TypeaheadMatch): void {   
    this.EmployeeFullName = e.item.displayName;  
  }
  typeaheadTravelerNoResults(event: boolean): void {   
    this.EmployeeFirstName = undefined;
    this.EmployeeLastName = undefined;
    this.EmployeeAlias = undefined    
    this.Department == undefined
    this.noResultTravelerName = event;
  }
  changeRequestorTypeaheadLoading(e: boolean): void {
    if (this.requestorNameChanged != false) {
      this.typeaheadRequestorLoading = e;
    }
  }
  Cancel() {
    this.modalService.hide(1);
    $('body').removeClass('modal-open');
  }
   //Will trigger after selecting the user from dropdown
   onselectClient(ClientObj) {
    this.flag = false;
    this.isSpinning = false;
    this.EmployeeEmail = ClientObj.mail.toLowerCase();
    var fullname = ClientObj.displayName
    let value = fullname.split(",")
    
  }
  Submit(requestorName) {
    let params = {
      statusId : InwardStatus.Collected,
      collectedBy:this.EmployeeEmail,
      collectedByName:requestorName,
      requestId :this.selectedRequest.requestId,
      updatedBy : localStorage.getItem('email')
    }

   let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "Check Materials";
    statusChangeAudit.newValue = "Collect Materials"

    auditData.push(statusChangeAudit);

    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        this.toast.success("Materials Successfully Collected");
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (err) => {
        console.log(err);
    },
    () => {
        //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

      this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // console.log(res);
      },
      (err) => {
        console.log(err);
      },
      () => {
        this.modalService.hide(1);
        window.location.reload();
      })
    })
  }

}
